export default __webpack_public_path__ + "static/media/small-logo.430c76db.svg";